import Image from "next/image";
import Partner1 from "../dao/Partner1";

const TechStack = () => {
  const techLogos = [
    {
      id: 1,
      name: "AWS",
      image: "/images/partners/aws.png",
    },
    {
      id: 2,
      name: "Blockchain",
      image: "/images/partners/blockchain.png",
    },
    {
      id: 3,
      name: "Alchemy",
      image: "/images/partners/alchemy.png",
    },
    {
      id: 4,
      name: "Polygon",
      image: "/images/partners/polygon.png",
    },
    {
      id: 5,
      name: "Ethereum",
      image: "/images/partners/ethereum.png",
    },
  ];

  return (
    <section className="relative py-16 overflow-hidden">
      <div className="absolute inset-0 bg-[#F8FAFC] dark:bg-[url('/images/our_ecosystem_gradient_dark.png')] bg-cover bg-center bg-no-repeat"></div>
      <div className="container mx-auto px-4 relative z-[2]">
        <div className="text-center mb-14">
          <h3 className="text-[#7E65FF] uppercase font-medium text-lg mb-3">
            TECH FOR GOOD
          </h3>
          <h1 className="text-4xl font-semibold dark:text-white text-grayish">
            Our Tech Stack
          </h1>
        </div>
      </div>
      <div className="mb-8 flex animate-marqueeRight space-x-8 relative z-[2]">
        <Partner1 />
      </div>
    </section>
  );
};

export default TechStack;
